'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = exports.DeleteButton = exports.ActionButtonWrapper = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _react = require('react');

var _reactAdmin = require('react-admin');

var _core = require('@material-ui/core');

var _styles = require('@material-ui/core/styles');

var _classnames = _interopRequireDefault(require('classnames'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      minWidth: theme.spacing(4),
    },
  };
});

var ActionButtonWrapper = function ActionButtonWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, ['children']);

  var classes = useStyles();

  var mergeClassName = function mergeClassName(child) {
    return _objectSpread({}, props, {
      className: (0, _classnames.default)(
        child.props.className,
        classes.button
      ),
    });
  };

  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
    textAlign: 'right',
    children: _react.Children.map(children, function (child) {
      return child && (0, _react.cloneElement)(child, mergeClassName(child));
    }),
  });
};

exports.ActionButtonWrapper = ActionButtonWrapper;

var DeleteButton = function DeleteButton(props) {
  var record = props.record;
  var trans = (0, _reactAdmin.useTranslate)();
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(
    _reactAdmin.DeleteWithConfirmButton,
    _objectSpread({}, props, {
      confirmTitle: trans('messages.delete_title', {
        name: record && record.name ? '"'.concat(record.name, '"') : 'item',
      }),
    })
  );
};

exports.DeleteButton = DeleteButton;

var ActionButtons = function ActionButtons(props) {
  var onDeleteFailure = props.onDeleteFailure,
    _props$showDelete = props.showDelete,
    showDelete = _props$showDelete === void 0 ? true : _props$showDelete,
    _props$showDetail = props.showDetail,
    showDetail = _props$showDetail === void 0 ? false : _props$showDetail,
    editComponent = props.editComponent,
    rest = _objectWithoutProperties(props, [
      'onDeleteFailure',
      'showDelete',
      'showDetail',
      'editComponent',
    ]);

  var renderEdit = (0, _react.useCallback)(
    function () {
      if (editComponent) {
        return editComponent();
      }

      return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactAdmin.EditButton, {
        label: '',
      });
    },
    [editComponent]
  );
  return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(
    ActionButtonWrapper,
    _objectSpread({}, rest, {
      children: [
        showDetail &&
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactAdmin.ShowButton, {
            label: '',
          }),
        renderEdit(),
        showDelete &&
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeleteButton, {
            label: '',
            onFailure: onDeleteFailure,
          }),
      ],
    })
  );
};

var _default = ActionButtons;
exports.default = _default;

//# sourceMappingURL=index.js.map
